// extracted by mini-css-extract-plugin
export default {"ConfirmDialog":"ConfirmDialog_ConfirmDialog__OGmrd","WrapperActions":"ConfirmDialog_WrapperActions__9YSMb","approve":"ConfirmDialog_approve__+lpK8"};